(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("4VgqT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $d4a7c0bddffd8504$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
const $d4a7c0bddffd8504$var$NoSearchResults = ({ searchTerm: searchTerm })=>{
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: "relative",
        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
            className: "absolute z-50 mt-3 left-0 w-full bg-grey10 shadow-bs80 max-h-xl overflow-y-auto rounded-md overflow-hidden p-3",
            children: [
                "Din s\xf6kning p\xe5 ",
                /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                    className: "font-icb",
                    children: searchTerm
                }),
                " gav inga resultat."
            ]
        })
    });
};
var $d4a7c0bddffd8504$export$2e2bcd8739ae039 = $d4a7c0bddffd8504$var$NoSearchResults;

});

})();
//# sourceMappingURL=NoSearchResults.fc4f51c9.js.map
